import type { RangeSpanT } from '../../../../common/types/types';
import { ACTION } from './constants';
export function updateAllAnnotationFrameSpan(annotationIdx: string, annotationSequence: Map<string, RangeSpanT>) {
  return {
    type: ACTION.UPDATE_ALL_ANNOTATION_FRAME_SPAN,
    annotationIdx,
    annotationSequence
  };
}
export function deleteAnnotationFrameSpan(annotationIdx: string, frameSpan: RangeSpanT) {
  return {
    type: ACTION.DELETE_ANNOTATION_FRAME_SPAN,
    annotationIdx,
    frameSpan
  };
}